var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "a",
            {
              staticClass: "mobile-navigation__brand",
              attrs: { href: _vm.homeURL }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "mobile-navigation__brand-logo",
                  attrs: { width: "162", height: "37" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_new-logo",
                      "xmlns:xlink": "https://www.w3.org/1999/xlink"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "mobile-navigation__close js-mobile-navigation__close",
              attrs: { href: "#" }
            },
            [
              _c("svg", { attrs: { width: "18", height: "18" } }, [
                _c("use", {
                  attrs: {
                    "xlink:href": "#svg_close-basketmodal",
                    "xmlns:xlink": "https://www.w3.org/1999/xlink"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-navigation__close-text" }, [
                _vm._v("Close")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown ddown-back",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c("svg", { attrs: { width: "17", height: "24" } }, [
                          _c("use", {
                            attrs: {
                              "xlink:href": "#svg_angle_left",
                              "xmlns:xlink": "https://www.w3.org/1999/xlink"
                            }
                          })
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate(
                                "Froschkoenig::Template.mobileNavBack"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dataContainer1.parent,
                      expression: "dataContainer1.parent"
                    }
                  ]
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "mobile-nav__all",
                      attrs: { href: _vm.parentUrl }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate(
                              "Froschkoenig::Template.mobileNavShowAll"
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "mobile-nav__slide",
                      class: { "mobile-nav__slide--sale": category.id === 288 },
                      attrs: { href: _vm.getCategoryUrl(category.url) }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(category.details[0].name) +
                          "\n                        "
                      ),
                      category.details[0].image2Path != "" &&
                      category.details[0].image2Path != null
                        ? _c("img", {
                            attrs: {
                              loading: "lazy",
                              width: "77",
                              height: "55",
                              src:
                                "/documents/" + category.details[0].image2Path,
                              alt: category.details[0].name
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "bi bi-chevron-right",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                viewBox: "0 0 16 16"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  d:
                                    "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown ddown-back",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c("svg", { attrs: { width: "17", height: "24" } }, [
                          _c("use", {
                            attrs: {
                              "xlink:href": "#svg_angle_left",
                              "xmlns:xlink": "https://www.w3.org/1999/xlink"
                            }
                          })
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate(
                                "Froschkoenig::Template.mobileNavBack"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.parentUrl
                ? _c("li", {}, [
                    _c(
                      "a",
                      {
                        staticClass: "mobile-nav__all",
                        attrs: { href: _vm.parentUrl }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "Froschkoenig::Template.mobileNavShowAll"
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(category.details[0].name) +
                          "\n                        "
                      ),
                      category.details[0].image2Path != "" &&
                      category.details[0].image2Path != null
                        ? _c("img", {
                            attrs: {
                              src:
                                "/documents/" + category.details[0].image2Path,
                              alt: category.details[0].name
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("svg", { attrs: { width: "17", height: "24" } }, [
                            _c("use", {
                              attrs: {
                                "xlink:href": "#svg_angle_right",
                                "xmlns:xlink": "https://www.w3.org/1999/xlink"
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }